import { render } from "./MOCType.vue?vue&type=template&id=9d9b841a&scoped=true"
import script from "./MOCType.vue?vue&type=script&lang=js"
export * from "./MOCType.vue?vue&type=script&lang=js"

import "./MOCType.vue?vue&type=style&index=0&id=9d9b841a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9b841a"]])

export default __exports__